import { getFormatByLanguage } from "./locales";

export function getFormattedDate(format = 'dd/mm/yyyy', dateString = null) {
  if (format == null)
    format = getFormatByLanguage();
  let date;
  if (dateString != null) {
    if (dateString.indexOf('T') == -1) {
      date = new Date(`${dateString}T00:00:00`);
    } else {
      date = new Date(dateString);
    }
  } else {
    date = new Date();
  }
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  if (format === 'dd/mm/yyyy') {
    return `${day}/${month}/${year}`;
  } else if (format === 'mm/dd/yyyy') {
    return `${month}/${day}/${year}`;
  } else if (format === 'yyyy/mm/dd') {
    return `${year}/${month}/${day}`;
  } else {
    return '';
  }
}

/**
 * Generates a Date object by sent date string
 * @param {String} dateString 
 * @returns 
 */
export function getDateObject(dateString) {
  let date = null;
  if (dateString != null) {
    if (dateString.indexOf('T') == -1) {
      date = new Date(`${dateString}T00:00:00`);
    } else {
      date = new Date(dateString);
    }
  } else {
    date = new Date();
  }
  return date;
}

/**
 * Returns the time in which the date happened accordingly to today, returning either the minutes, hours, day, and months 
 */
export function getDateDifferenceInText(past = null) {
  if (!past) {
    past = new Date();
  } else if (typeof past === "string" || typeof past === "number") {
    past = new Date(past);
  }

  const now = new Date();
  const diffInSeconds = Math.abs(Math.floor((now - past) / 1000));

  if (diffInSeconds < 60) {
    return `${diffInSeconds} segundos atrás`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minutos atrás`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} horas atrás`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return `${diffInDays} dias atrás`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  return `${diffInMonths} meses atrás`;
}